export const setCategoriaToSelect = (estados) =>
  sessionStorage.setItem("categorias", JSON.stringify(estados));
export const getCategoriaToSelect = () =>
  JSON.parse(sessionStorage.getItem("categorias"));
